import React from "react";
import {
  SIGN_IN_LANDING_PAGE,
  SIGN_IN_OTP_PAGE,
  SIGN_IN_WITH_PASSWORD_PAGE,
  SUCCESS_AUTH
} from "../../../constants/variables";
import SuccessAuth from "../success";
import SignInLandingPage from "./SignInLandingPage";
import SignInOTPPage from "./SignInWithOTP";
import SignInWithPassword from "./SignInWithPassword";

function SignInModule(props) {
  const [state, setState] = React.useState(SIGN_IN_LANDING_PAGE);
  const [emailOrMobile, setEmailOrMobile] = React.useState<string>("");
  const [OTP, setOTP] = React.useState<string>("");
  const {resourceData} = props;

  // ?accepts a state key (such as SIGN_UP_LANDING_PAGE) as param and updates the state with it
  const handleState = (updatedState: React.SetStateAction<string>) => {
    setState(updatedState);
  };

  // ?  depending on the state, return the respective page screen
  return (
    <div className="h-full w-full">
      {state === SIGN_IN_LANDING_PAGE ? (
        <SignInLandingPage
          handleOpen={props.handleOpen}
          handleState={handleState}
          handleModule={props.handleModule}
          resourceData={props.resourceData}
          setEmailOrMobile={setEmailOrMobile}
          emailOrMobile={emailOrMobile}
        />
      ) : state === SIGN_IN_OTP_PAGE ? (
        <SignInOTPPage
          handleOpen={props.handleOpen}
          handleState={handleState}
          resourceData={props.resourceData}
          OTP={OTP}
          setOTP={setOTP}
          emailOrMobile={emailOrMobile}
          handleSuccess={props.handleSuccess}
        />
      ) : state === SIGN_IN_WITH_PASSWORD_PAGE ? (
        <SignInWithPassword
          handleOpen={props.handleOpen}
          handleState={handleState}
          handleModule={props.handleModule}
          resourceData={props.resourceData}
          handleSuccess={props.handleSuccess}
        />
      ) : state === SUCCESS_AUTH ? (
        <SuccessAuth message={resourceData?.logInSuccess} handleOpen={props.handleOpen} />
      ) : null}
    </div>
  );
}

export default SignInModule;
